import { PARTNER360_NAMESPACE } from 'legacy/lut/features/partner360/common/constants'

export const PARTNER360_COMPETITORS_SOB_NAMESPACE = `${PARTNER360_NAMESPACE}/COMPETITORS-SOB`

// Async thunk constants
export const REQUEST_COMPETITORS_SOB = `${PARTNER360_COMPETITORS_SOB_NAMESPACE}/requestCompetitorsSob`
export const REQUEST_COMPETITORS_FOR_SELECT = `${PARTNER360_COMPETITORS_SOB_NAMESPACE}/requestCompetitorsForSelect`
export const REQUEST_APPLY_CHANGES = `${PARTNER360_COMPETITORS_SOB_NAMESPACE}/requestApplyChanges`
export const REQUEST_COMPETITORS_SOB_COMMENT = `${PARTNER360_COMPETITORS_SOB_NAMESPACE}/requestCompetitorsSobComment`
export const REQUEST_APPLY_COMPETITORS_SOB_COMMENT = `${PARTNER360_COMPETITORS_SOB_NAMESPACE}/requestApplyCompetitorsSobComment`

// Other
export const observedFields = [
  'CurrentYearQ1Actuals',
  'CurrentYearQ1ActualsSob',

  'CurrentYearQ2Actuals',
  'CurrentYearQ2ActualsSob',

  'CurrentYearQ3Actuals',
  'CurrentYearQ3ActualsSob',

  'CurrentYearQ4Actuals',
  'CurrentYearQ4ActualsSob',

  'CurrentYearFYActuals',
  'CurrentYearFYActualsSob',

  'PrevYearQ1Actuals',
  'PrevYearQ1ActualsSob',

  'PrevYearQ2Actuals',
  'PrevYearQ2ActualsSob',

  'PrevYearQ3Actuals',
  'PrevYearQ3ActualsSob',

  'PrevYearQ4Actuals',
  'PrevYearQ4ActualsSob',

  'PrevYearQ4YoYActuals',
  'PrevYearQ4YoYActualsSob',

  'PrevYearFYActuals',
  'PrevYearFYActualsSob',

  'PrevYearFYYoYActuals',
  'PrevYearFYYoYActualsSob',
]

export const CURRENT_YEAR_PREFIX = 'CurrentYear'

export const PREV_YEAR_PREFIX = 'PrevYear'

export const PREV_PREV_YEAR_PREFIX = 'PrevPrevYear'

export const HP_COMPETITOR_ID = 'jbp-competitor-hp' // Actuals
export const HP_COMPETITOR_PLAN_ID = 'jbp-competitor-hp-plan' // Plan

export const OTHER_COMPETITOR_ID = 'jbp-competitor-other'

export const sobFields = [
  'PrevYearQ1ActualsSob',
  'PrevYearQ2ActualsSob',
  'PrevYearQ3ActualsSob',
  'PrevYearQ4ActualsSob',
  'CurrentYearQ1ActualsSob',
  'CurrentYearQ2ActualsSob',
  'CurrentYearQ3ActualsSob',
  'CurrentYearQ4ActualsSob',
]

export const fieldsToRecalculate = sobFields
